import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import {
  CONTACT_EMAIL,
  GOOGLE_FORM_URL,
  TIKTOK_URL,
  FACEBOOK_URL,
  YOUTUBE_URL,
  SNAPCHAT_URL,
  INSTAGRAM_URL,
} from "../constants";

export default function Footer() {
  return (
    <footer>
      <div className="footer-top">
        <Link to="/" className="footer-brand">Lutuu</Link>
        <p>Întâmplări reale din traficul românesc.</p>
        <div className="footer-links">
          <Link to="/">Acasă</Link>
          <Link to="/blog">Blog</Link>
          <a href={GOOGLE_FORM_URL} target="_blank" rel="noopener noreferrer">Trimite un clip</a>
          <Link to="/urmareste-ne">Urmărește-ne pe:</Link>
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </div>
      </div>
      <div className="footer-socials">
        <a href={TIKTOK_URL} target="_blank" rel="noreferrer">TikTok <ArrowUpRight size={13} /></a>
        <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer">Instagram <ArrowUpRight size={13} /></a>
        <a href={YOUTUBE_URL} target="_blank" rel="noreferrer">YouTube <ArrowUpRight size={13} /></a>
        <a href={FACEBOOK_URL} target="_blank" rel="noreferrer">Facebook <ArrowUpRight size={13} /></a>
        <a href={SNAPCHAT_URL} target="_blank" rel="noreferrer">Snapchat <ArrowUpRight size={13} /></a>
      </div>
      <div className="footer-bottom">
        <span className="copyright">© {new Date().getFullYear()} Lutuu</span>
        <span className="footer-credit">Dezvoltat de <a href="https://paulweb.eu" target="_blank" rel="noreferrer">paulweb.eu</a></span>
      </div>
    </footer>
  );
}
